import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueHead from 'vue-head'
//import axios from 'axios'
import VuePaginate from 'vue-paginate'
import i18n from './i18n'
import store from './store'
import $ from 'jquery'
//import VueAwesomeSwiper from 'vue-awesome-swiper'
//import 'swiper/css/swiper.css'
//Vue.use(VueAwesomeSwiper);
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)

Vue.config.productionTip = false

//Vue.use(axios)
Vue.use(VueHead, {
  separator: ''
})
Vue.use(VuePaginate)

Vue.directive('select2', {
  inserted(el) {
      $(el).on('select2:select', () => {
          const event = new Event('change', { bubbles: true, cancelable: true });
          el.dispatchEvent(event);
      });

      $(el).on('select2:unselect', () => {
          const event = new Event('change', {bubbles: true, cancelable: true})
          el.dispatchEvent(event)
      })
  },
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
